import React from "react";
import "../styles/FloatingWhatsapp.css";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsapp = () => {

  const phone = "923039692162";

  const message =
    "Hello, I visited the ITWORLD website and would like to know more about your fuel station solutions.";

  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp"
    >
      <div className="whatsapp-icon">
        <FaWhatsapp />
      </div>

      <div className="whatsapp-text">
        <span>WhatsApp Us</span>
        <small>Available Now</small>
      </div>
    </a>
  );
};

export default FloatingWhatsapp;